import React from "react";
import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import StartRecording from "./Recorder/StartRecording";
import PrivateRoute from "../PrivateRoute";
import Recording from "./Recorder/Recording";
import MessageSequence from "./Recorder/MessageSequence";
import Login from "./Login";
import Logout from "./Logout";
import InteractiveBus from "./InteractiveBus/InteractiveBus";
import Services from "./Services/Services";
import PushLogs from "./PushLogs/PushLogs";
import Library from "./Library/Library";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={["/", "/login"]} component={Login} exact />
        <Route path="/logout" component={Logout} exact />
        <PrivateRoute path="/recording" component={StartRecording} exact />
        <PrivateRoute path="/recording/:id" component={Recording} exact />
        <PrivateRoute path="/recording/:id/:reqId" component={MessageSequence} exact />
        <PrivateRoute path="/interactive-bus" component={InteractiveBus} />
        <PrivateRoute path="/services" component={Services} exact />
        <PrivateRoute path="/push-logs" component={PushLogs} exact />
        <PrivateRoute path="/library" component={Library} />
        <Redirect to="/recording" />
      </Switch>
    </BrowserRouter>
  );
};

export default AppRouter;
